<script>
export default {
  name: 'partners'
};
</script>

<template>
  <div class="partner">
    <div class="left-title">战略合作商</div>
    <div class="right-content">
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-27.png" alt="">
        <span class="company-name">中科招商保理公司</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-18.png" alt="">
        <span class="company-name">厦门港务集团</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-4.png" alt="">
        <span class="company-name">中储粮业集团</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-16.png" alt="">
        <span>广东农垦集团</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-25.png" alt="">
        <span>光明集团</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-6.png" alt="">
        <span>无锡华顺民生</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-35.png" alt="">
        <span>江苏双鱼食品</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-19.png" alt="">
        <span>苏州松鹤楼</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-29.png" alt="">
        <span>华味亨</span>
      </div>
      <div class="cell">
        <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/resources-14.png" alt="">
        <span>张家港市永乐</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.partner {
  width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  padding: 24px;

  .left-title {
    font-weight: 800;
    font-size: 18px;
    color: #333333;
    margin-bottom: 33px;
  }

  .right-content {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 16px;

    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border: 1px solid #DCDCDC;
      padding-bottom: 10px;
      font-size: 12px;
      color: #333333;
      img {
        width: 175px;;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index/partners.vue